// extracted by mini-css-extract-plugin
export default {"bottomHeaderSection":"BottomHeaderSection_bottomHeaderSection__AvIKp"};